import {useMemo} from "react";
import formFieldsJson from "../../infrastructure/data/formFields.json";
import {Department} from "domain/types/clientMetadataTypes";
import {FormValues} from "domain/types";

export interface OptionItem {
    value: string;
    label: string;
}

export interface FormField {
    name: keyof FormValues;
    label: string;
    required: boolean;
    options: OptionItem[];
}

type Props = {
    departments?: Department[];
};

export function useInitialFormFields({departments = []}: Props): FormField[] {
    return useMemo(() => {
        const formFields = formFieldsJson as FormField[];

        return formFields.map((field) => {
            if (field.name === "departamentoSeccionArea") {
                return {
                    ...field,
                    options: departments.map((item) => ({
                        value: item.name,
                        label: item.name,
                    })),
                };
            }

            return field;
        });
    }, [departments]);
}
